import { httpClient } from '@/services/http/httpClient'

type UpdateMaxUsersParams = {
  tennantId: string
  maxUsers: number | null
}

export async function updateMaxUsers({
  tennantId,
  maxUsers,
}: UpdateMaxUsersParams): Promise<void> {
  await httpClient.patch('/tennants/max-users', { tennantId, maxUsers })
}
